export default "__VITE_ASSET__18410544__"